// extracted by mini-css-extract-plugin
export var tablet_min = "768px";
export var desktop_min_sm = "992px";
export var desktop_min = "1100px";
export var desktop_min_lg = "1220px";
export var popup_breakpoint = "1399px";
export var headerTitle = "w_bH";
export var headerByline = "w_bJ";
export var headerImage = "w_bK";
export var headerTextPortion = "w_bL";